module.exports = __webpack_public_path__ + "static/media/8.89c17578.jpg";